import React, { Component } from 'react';
import './Loading.css';

class Loading extends Component {
  render() {
    let svg = <div className="loading--circle" title="Loading">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">
        <path d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z" stroke="#6411db">
          <animateTransform attributeType="XML" attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="0.6s" repeatCount="indefinite" />
        </path>
      </svg>
    </div>;

    if (this.props.plane)
      svg = <div className="loading--plane" title="Loading">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 113.5 104">
          <path
            d="M97.7 41.5c16.3 0 16.3 21-.2 21H66.7l-26 38H29.2l14.1-38h-23l-7.8 10h-9L8.2 52 3.5 31.5h9l7.8 10h23.1l-14.1-38h11.4l26 38h31z"
            fill="none"
            strokeWidth="4"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            stroke="#6411db"
          />;
        </svg>
      </div>;

    return (
      <div className="loading">
        <div className="content">
          {svg}
        </div>
      </div>
    );
  }
}

export default Loading;